export const DutchData = [
  { 
    heading: "Beoordelingstool Pilot",
    atpSection: {
      introMessage: {
        quote: "We overwegen een AI-voertuigwaarderingstool om te revolutioneren hoe we voertuigen waarderen. Uw deelname aan deze pilot is onschatbaar nu we voorop lopen in het benutten van technologie om onze klanten beter van dienst te zijn.",
        author: {
          name: "Antonio Ward",
          designation: "Algemeen Directeur - Afgewerkte Voertuigen",
          photo: '/Assets/images/photo.jpg',
        }
      },
      introVideoTitle: "Introductie van de pilot"
    },
    purposeSection: {
      heading: "Doel van de pilot",
      description: "Gebruik de apps van focalx om te zien of u gemakkelijk taxaties kunt maken",
      taskHeading: "Uw taken",
      tasks: [
        "Bookmark deze landingspagina",
        'Installeer de "Auto Inspection" app. (Scan de QR-code onderaan deze pagina)',
        "Log in met de inloggegevens die door uw manager zijn verstrekt.",
        "Maak alle foto's van de auto wanneer u een inspectie uitvoert",
        "Vul de VASCOR-enquête in nadat u elk rapport heeft ontvangen."
      ],
      timelineHeading : "Pilot tijdlijn",
    },
    inspectionSection: {
      heading: "Inspectietraining: Hoe voert u een inspectie uit met de app?",
      downloadManual: "Handleiding downloaden",
      relatedVideosTitle: "Bekijk hier onze 30 seconden tutorials:",
      relatedVideos: [
        {
          poster: '/Assets/images/user-flow-poster.png',
          video: "app-demo-walkthrough.mp4",
          title: "1. Gebruikersstroom:",
          description: "Snel end-to-end overzicht van de gebruikersstroom.",
          time: "0m24s"
        },
        {
          poster: '/Assets/images/Video-01.png',
          video: "app-demo-walkthrough.mp4",
          title: "2. Downloaden en installeren:",
          description: "Beschikbaar zowel in de App Store als Google Play, download en installeer de 'Auto Inspection' app en start uw inspecties.",
          time: "0m24s"
        },
        {
          poster: '/Assets/images/Video-03.png',
          video: 'app-demo-walkthrough.mp4',
          title: "3. Inspecties toevoegen:",
          description: "Scan het kenteken of het VIN, voeg het type voertuig toe en start uw nieuwe inspectie.",
          time: "0m16s"
        },
        {
          poster: '/Assets/images/Video-04.png',
          video: "app-demo-walkthrough.mp4",
          title: "4. AI-begeleiding inspectiesysteem:",
          description: "Leg uw voertuig vast met behulp van ons AI-begeleidingssysteem en laat uw schades detecteren en documenteren in de app.",
          time: "0m26s"
        },
        {
          poster: '/Assets/images/Video-02.png',
          video: "app-demo-walkthrough.mp4",
          title: "5. Inspecties bekijken:",
          description: "Bekijk uw inspecties door te bladeren door de gedocumenteerde schades en afbeeldingen van uw voertuig.",
          time: "0m30s"
        },
        {
          poster: '/Assets/images/Video-07.png',
          video: "app-demo-walkthrough.mp4",
          title: "6. PDF-rapport downloaden:",
          description: "Download het volledige schaderapport van uw voertuig op uw telefoon voor snelle toegang.",
          time: "0m20s"
        },
        {
          poster: '/Assets/images/Video-05.png',
          video: "app-demo-walkthrough.mp4",
          title: "7. Handmatig schade toevoegen:",
          description: "Voeg eventuele extra schade toe via de 'Schade toevoegen' functie.",
          time: "0m39s"
        },
        {
          poster: '/Assets/images/Video-08.png',
          video: "app-demo-walkthrough.mp4",
          title: "8. Inloggen en uw voltooide inspecties bekijken:",
          description: "Ontvang een e-mail met alle afbeeldingen van uw voertuig en gedetecteerde schades en log in met uw inloggegevens in het websysteem om uw inspecties te bekijken.",
          time: "0m57s"
        },
        {
          poster: '/Assets/images/Video-09.png',
          video: "app-demo-walkthrough.mp4",
          title: "9. Hoe stuur ik unieke links naar de klant?",
          description: "Een kort overzicht van hoe u uw klanten een link kunt sturen zodat ze een voertuiginspectie kunnen uitvoeren.",
          time: "0m57s"
        }
      ]       
    },
    helpSection: {
      heading: "We zijn hier 24/7 om te helpen",
      chatHeading: "Chat met ons",
      emailHeading: "Stuur ons een e-mail",
      chat: {
        intercom: "Intercom",
        whatsapp: "+502-570-3238",
        weChat: "WeChat",
        emailAddress: "contact@focalx.ai"
      },
      formHeading: "Laat ons een bericht achter en laat uw e-mailadres achter",       
      form: {
        nameFiled: "Voer naam in",
        emailField: "Voer e-mailadres in",
        commentField: "Voer bericht in",
        buttonText: "Verzenden",
      }
    },
    faqSection: {
      heading: "Veelgestelde vragen",
      accordionItems: [
        {
          accordianTitle: "Moeten de afbeeldingen passen bij de sjablonen?",
          accordianContent: ["Nee, dat hoeft niet. Doe uw best en hoe dichter bij de auto u de foto maakt, hoe beter. Maar de sjablonen zijn er alleen om u te oriënteren op welke afbeelding u moet maken."]
        },
        {
          accordianTitle: "Hoe lang duurt het voordat ik mijn resultaten krijg?",
          accordianContent: ["Zodra alle afbeeldingen van het voertuig zijn geüpload, moeten de resultaten binnen maximaal 30 minuten in uw inbox staan. Dit komt omdat dit een pilot is en het de eerste week is. Hoe meer u de app gebruikt, hoe meer hij leert en hoe sneller hij wordt."]
        },
        {
          accordianTitle: "Wat betekenen deze K1, K2...K5?",
          accordianContent: [
            "K1: Dit kunt u wegpoetsen", 
            "K2: Dit kunt u polijsten", 
            "K3: Kleine schade die u niet zelf kunt repareren", 
            "K4: Een professional moet dit repareren", 
            "K5: Het onderdeel moet mogelijk worden vervangen"]
        },
        {
          accordianTitle: "Moet de auto worden schoongemaakt voordat deze wordt getaxeerd?",
          accordianContent: ["Niet noodzakelijk. Het systeem detecteert schades zelfs als de auto niet schoon is. Maar het is geen magie, dus als het menselijk oog de schade niet kan zien en de schade niet te zien is op de foto, kan de AI het niet detecteren."]
        },
        {
          accordianTitle: "Moet ik alle afbeeldingen maken?",
          accordianContent: ["Ja, voor het systeem om zijn analyse uit te voeren, moeten alle afbeeldingen worden gemaakt en geüpload om een gestandaardiseerd en grondig taxatierapport te garanderen."]
        },
        {
          accordianTitle: "Worden de gegevens van de klant gedeeld?",
          accordianContent: ["Nee, dat zullen ze niet. Er worden geen namen of klantgegevens gedeeld in deze pilot en geen van de gegenereerde gegevens wordt gebruikt voor commerciële doeleinden, behalve voor VASCOR en u om de prestaties van deze tool te evalueren."]
        },
        {
          accordianTitle: "Wat moet ik doen als ik een onjuistheid zie of een probleem heb met de app?",
          accordianContent: ["Zorg ervoor dat u contact opneemt met de ondersteuning, zij zullen u begeleiden bij een oplossing. Maar vergeet niet om het ook te vermelden in uw post-taxatie-enquête. Hoe meer details u kunt verstrekken, hoe beter."]
        }          
      ]
    },
    downloadSection: {
      content: {
        downloadNow: "Nu downloaden",
        autoInspection: "Auto Inspectie",
        description: "Vind het in de App Store of Google Play door ernaar te zoeken of de onderstaande QR-code te scannen.",    
      }
    },
    footer: "© FocalX ApS. Alle rechten voorbehouden.",
    lockScreen: {
      title: "Voer PIN in om toegang te krijgen",
      buttonText: "Verifiëren",
    },
  }
];
